module.exports = __webpack_public_path__ + "img/gebco_bathy.2700x1350_8bit.68103a6b.jpg";